<template>
  <footer class="footer shadow-sm" style="z-index: 2000; position: fixed !important;">
    <div class="container-boxed">
      <div class="row">
        <div class="col-sm-6">
          <img
            src="../assets/logo.jpg"
            alt=""
            style="width: 160px;height: 60px;position: absolute;top: -20px;"
          />
        </div>
        <div class="col-sm-6">
          <div class="text-sm-end">{{ version }}</div>
          <div class="text-sm-end">©NASH 2022 All Rights Reserved</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { APP_VERSION } from "../config/common";
export default {
  data() {
    return {
      version: APP_VERSION,
    };
  },
};
</script>
